import { STATIC_PG_META, UPDATE_STATIC_PG_META } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const Static_pg_meta = (payload) => {
    return apiInstance.post(STATIC_PG_META, payload);
};

export const Update_Static_pg_meta = (payload) => {
    return apiInstance.post(UPDATE_STATIC_PG_META, payload);
};
